import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { softwareDeploymentsEntrypoint } from '@atlassian/jira-spa-apps-software-deployments/entrypoint.tsx';

export const softwareDeploymentsPageEntrypoint = createPageEntryPoint({
	main: softwareDeploymentsEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});
